window.timedPopup = function (config) {
    const delay = typeof config?.delay === 'number' ? config.delay : 8000;
    const version = config?.version || '';
    const storageKey = version ? `timed_popup_dismissed_${version}` : 'timed_popup_dismissed';
    const aliases = {
        whiteley: 'The Whiteley',
        thewhiteley: 'The Whiteley',
        queenspark: "Queen's Park",
        "queens-park": "Queen's Park",
    };

    // Decode HTML entities (basic)
    const decodeEntities = (str) => {
        if (!str || typeof str !== 'string') return '';
        const textarea = document.createElement('textarea');
        textarea.innerHTML = str;
        return textarea.value;
    };

    const normalize = (value) => {
        let decoded = decodeEntities(value || '');
        return decoded
            .toLowerCase()
            .replace(/&/g, ' and ')
            .replace(/['’]/g, '') // Remove apostrophes
            .replace(/[^a-z0-9]/g, ''); // Remove all non-alphanumeric
    };

    const getClubFromSlug = () => {
        const match = window.location.pathname.match(/\/clubs\/([^/]+)/i);
        if (!match || !match[1]) {
            return '';
        }

        const slug = decodeURIComponent(match[1]).trim().toLowerCase();
        const compactSlug = normalize(slug);
        if (aliases[compactSlug]) {
            return aliases[compactSlug];
        }

        return slug
            .split('-')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    const getTargetClub = (rootEl) => {
        const postType = (rootEl?.dataset?.currentPostType || '').toLowerCase();
        const currentClubName = rootEl?.dataset?.currentClubName || '';

        if (postType === 'clubs' && currentClubName.trim()) {
            return currentClubName.trim();
        }

        return getClubFromSlug();
    };

    const autoSelectClub = (rootEl) => {
        if (!rootEl || rootEl.dataset.clubSelected === '1') {
            return true;
        }

        const targetClub = getTargetClub(rootEl);
        if (!targetClub) {
            return true;
        }

        const select = rootEl.querySelector('select[name="location"], select[id^="location-"]');
        if (!select) {
            return false;
        }

        if (select.value && select.value.trim() !== '') {
            rootEl.dataset.clubSelected = '1';
            return true;
        }

        const targetNormalized = normalize(targetClub);
        const options = Array.from(select.options || []);

        const matched = options.find((option) => {
            const optionText = normalize(option.textContent || '');
            const optionValue = normalize(option.value || '');
            return optionText === targetNormalized || optionValue === targetNormalized;
        });

        if (!matched || !matched.value) {
            return true;
        }

        select.value = matched.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        rootEl.dataset.clubSelected = '1';
        return true;
    };

    const scheduleAutoSelect = (rootEl, retries = 10) => {
        const completed = autoSelectClub(rootEl);
        if (completed || retries <= 0) {
            return;
        }

        setTimeout(() => {
            scheduleAutoSelect(rootEl, retries - 1);
        }, 300);
    };

    return {
        visible: false,
        init() {
            try {
                if (window.sessionStorage && window.sessionStorage.getItem(storageKey) === '1') {
                    return;
                }
            } catch (e) {}

            setTimeout(() => {
                this.visible = true;
                scheduleAutoSelect(document.querySelector('[data-timed-popup]'));
            }, delay);
        },
        close() {
            this.visible = false;
            try {
                if (window.sessionStorage) {
                    window.sessionStorage.setItem(storageKey, '1');
                }
            } catch (e) {}
        },
    };
};

